import Vue from 'vue';
import parsePhoneNumberFromString from 'libphonenumber-js';

import { GROUP_PARAMS_ERRORS } from '@/components/devices/Registrator/config';

export default class GroupParamsService {
  getParams(groupParamId) {
    Vue.prototype.$crudService
      .get(`device/group_params/${groupParamId}`)
      .then(({ data }) => {
        Vue.prototype.$store.groupParamTitles = data.group_param.kiosk_title;
        Vue.prototype.$store.groupElements = data.group_param_elements.map(
          this.mapElement,
        );
      });
  }

  mapElement(paramElement) {
    return { ...paramElement, data: '' };
  }

  reset() {
    Vue.prototype.$store.groupParamTitles = undefined;
    Vue.prototype.$store.groupElements = undefined;
  }

  /**
   * @returns {{error: string, invalidElement: Object}}
   */
  validateGroupParams() {
    if (
      !Vue.prototype.$store.groupElements ||
      !Vue.prototype.$store.groupElements.length
    ) {
      return { error: '', invalidElement: {} };
    }

    let error;
    const invalidElement = Vue.prototype.$store.groupElements.find(
      ({ required, length, min_length, type, data }, index) => {
        if (required) {
          error = !data.length && GROUP_PARAMS_ERRORS.REQUIREMENT_ERROR;
        }
        if (!error && length) {
          if(data.length < min_length) {
            error = data.length < min_length && GROUP_PARAMS_ERRORS.MIN_LENGTH_ERROR;
          }
          if(data.length > length) {
            error = data.length > length && GROUP_PARAMS_ERRORS.MAX_LENGTH_ERROR;
          }
        }
        if (!error && type === 'phone') {
          const parsedPhone = parsePhoneNumberFromString(data);

          error =
            (!parsedPhone || !parsedPhone.isValid()) &&
            GROUP_PARAMS_ERRORS.PHONE_ERROR;
        }

        return !!error;
      },
    );

    return { error, invalidElement };
  }

  generateAdditionalInfo() {
    if (
      !Vue.prototype.$store.groupElements ||
      !Vue.prototype.$store.groupElements.length
    ) {
      return {};
    }

    const result = {};
    Vue.prototype.$store.groupElements.forEach(({ id, data }) => {
      if (data) {
        result[id] = data;
      }
    });

    return result;
  }
}
